import React, { useCallback } from 'react'
import GoogleLogin from 'react-google-login'
import PropTypes from 'prop-types'

import {
  getEnvironmentVariable,
  showErrorNotification,
} from '../../../core/helpers'

const GoogleLoginButton = ({ onSuccess }) => {
  const clientId = getEnvironmentVariable('REACT_APP_GOOGLE_CLIENT_ID')

  const onFailure = useCallback(error => {
    showErrorNotification({
      title: 'Login with Google failed.',
      description: error.message,
    })
  }, [])

  return (
    <GoogleLogin
      clientId={clientId}
      buttonText="Login"
      onSuccess={onSuccess}
      onFailure={onFailure}
    />
  )
}

GoogleLoginButton.propTypes = {
  onSuccess: PropTypes.func.isRequired,
}

export default GoogleLoginButton
